import React from 'react'
import { useTranslation } from 'react-i18next'

import Button from '../../../../../components/Button'
import RadioBlock from '../../../../../components/Form/RadioBlock'
import MarginField from './MarginFields/MarginField'

import { getAppDomainName } from '../../../../../features/helpers/getAppDomainName'

import { DIFFERENT_MARGIN, GENERAL_MARGIN, MARGIN_OPTION, MARGINS, NO_MARGIN, SAME_MARGIN } from './MarginFields/fields'
import {
  FACEBOOK_PROVIDER_PLATFORM,
  GOOGLE_PROVIDER_PLATFORM,
  TIKTOK_PROVIDER_PLATFORM,
  DV_360_PROVIDER_PLATFORM
} from '../../../../../constants/selectLists/platformList'

import useMarginFieldStyles from './MarginFields/styles'
import useCommonStyles from '../../../../../styles/common/stepForms'

const stepFields = [MARGIN_OPTION, MARGINS, GENERAL_MARGIN]

function AllCampaignsMarginStep({ formik, handleStepChange }) {
  const { t } = useTranslation()

  const marginFieldClasses = useMarginFieldStyles()
  const commonClasses = useCommonStyles()

  const appName = getAppDomainName()

  const { values, setFieldValue } = formik

  const handleContinue = () => {
    handleStepChange(stepFields, formik.values)
  }

  return (
    <>
      <div className={commonClasses.stepTitle}>{t('Please enter the margin % you want to add to the media cost')}</div>
      <div className={commonClasses.stepBody}>
        <RadioBlock
          setFieldValue={setFieldValue}
          id="radio_same_margin"
          name={MARGIN_OPTION}
          value={SAME_MARGIN}
          selectedValue={values[MARGIN_OPTION]}
          label={t('I want to apply the same margin to all ad platforms')}
        >
          <p>Please enter the % amount that you want to make.</p>
          <p>
            For example, if the partner spends $100 and you want to make $60, then enter 60%. {appName} will ensure that
            the media cost in the ad platform is $40.
          </p>
          <MarginField formik={formik} name={GENERAL_MARGIN} />
        </RadioBlock>
        <RadioBlock
          setFieldValue={setFieldValue}
          id="radio_different_margin"
          name={MARGIN_OPTION}
          value={DIFFERENT_MARGIN}
          selectedValue={values[MARGIN_OPTION]}
          label={t('I want to apply different margins per ad platform')}
        >
          <p>Please enter the % amount that you want to make.</p>
          <p>
            For example, if the partner spends $100 and you want to make $60, then enter 60%. {appName} will ensure that
            the media cost in the ad platform is $40.
          </p>
          <div className={marginFieldClasses.marginValue}>
            <div className={marginFieldClasses.platform}>Facebook</div>
            <MarginField formik={formik} name={`${MARGINS}.${FACEBOOK_PROVIDER_PLATFORM}`} />
          </div>
          <div className={marginFieldClasses.marginValue}>
            <div className={marginFieldClasses.platform}>Google Ads</div>
            <MarginField formik={formik} name={`${MARGINS}.${GOOGLE_PROVIDER_PLATFORM}`} />
          </div>
          <div className={marginFieldClasses.marginValue}>
            <div className={marginFieldClasses.platform}>DV360</div>
            <MarginField formik={formik} name={`${MARGINS}.${DV_360_PROVIDER_PLATFORM}`} />
          </div>
          <div className={marginFieldClasses.marginValue}>
            <div className={marginFieldClasses.platform}>TikTok</div>
            <MarginField formik={formik} name={`${MARGINS}.${TIKTOK_PROVIDER_PLATFORM}`} />
          </div>
        </RadioBlock>
        <RadioBlock
          setFieldValue={setFieldValue}
          id="radio_no_margin"
          name={MARGIN_OPTION}
          value={NO_MARGIN}
          selectedValue={values[MARGIN_OPTION]}
          label={t('I don’t want to apply any margin on this account')}
        />
      </div>
      <div className={commonClasses.stepFooter}>
        <Button type="button" className="dark" onClick={handleContinue}>
          {t('Continue')}
        </Button>
      </div>
    </>
  )
}

export default AllCampaignsMarginStep
